export default __webpack_public_path__ + "static/media/spinner.69571ac7.gif";